import {$, $$, get, getDataText,  clickOnEnterKey, gtmSimpleEvent, updateLanguageUrls} from "@/Utils";
import {EditCartFrom, GtmEventType} from "@/enums";

function selectTab(targetTab: HTMLElement) {
  targetTab.closest(".tabs-menu__list").querySelectorAll(".tabs-menu__item--active").forEach(x => {
    x.classList.remove("tabs-menu__item--active");
    const contentIdToHide = x.getAttribute("data-tab-id");
    let sectionToHide = get(contentIdToHide);
    sectionToHide?.classList.remove("tab-content--active");
  });
  targetTab.classList.add("tabs-menu__item--active");
  const target = targetTab.getAttribute("data-tab-id");
  gtmSimpleEvent(GtmEventType.Tab, target);
  let targetSection = get(target);
  if (!targetSection){
      console.warn(`Section for tab: "${target}" not found`)
  }
  let targetClassList = targetSection?.classList;
    targetClassList?.add("tab-content--active");
  updateLanguageUrls(targetTab);
}

function onTabClick(e: Event) {
    const targetTab = e.currentTarget as HTMLElement
    e.preventDefault()
    if (targetTab.dataset.lazy === ""){
        const product = $(`[data-product-list-id="${EditCartFrom.ProductDetail}"]`)
        const id = product.getAttribute("data-product-id")
        let tabContentUrl : string;
        if (targetTab.dataset.tabId === "_CompatiblesTab"){
            tabContentUrl = window.config.compatibleProductsTabUrl;
        }
        else if (targetTab.dataset.responsivePanelTarget === "similar-products"){
            tabContentUrl = window.config.similarProductsTabUrl;
        }
        if (tabContentUrl){
            getDataText(tabContentUrl + "/" + id, (resp)=> {
                let tabContent = document.querySelector(`#${targetTab.dataset.responsivePanelTarget} .responsive-panel`);
                tabContent.innerHTML = resp;
                targetTab.dataset.lazy = "loaded"
            });
        }
    }
    const alreadyOpen = targetTab.classList.contains("tabs-menu__item--active")
    if (alreadyOpen) {
        return
    }
    const activateOtherTab = targetTab.getAttribute("data-activate-tab")
    let tabId = ""
    if (activateOtherTab) {
        const tabToActivate = targetTab.getAttribute("data-tab-id")
        tabId =`${tabToActivate}Link`
            selectTab(get(tabId))
    } else {
        tabId = targetTab.id
        selectTab(targetTab)
    }
    const url = targetTab.getAttribute("data-url")
    if (url) {
        history.pushState({tabId: tabId}, null, url)
    }
}

export function initTabs() {
  $$(".tabs-menu__list").forEach(list => {
      list.querySelectorAll(".tabs-menu__link").forEach(x => {
          x.setAttribute("tabindex", "0");
      })
    let activeTab = list.querySelector(".tabs-menu__item--active");
    if(!activeTab){
        // No active tabs, make first one active, if it exists
        activeTab = list.querySelector(".tabs-menu__item")
        activeTab?.classList.add("tabs-menu__item--active")
    }
    const tab = activeTab?.getAttribute("data-tab-id");
    if (tab) {
      const tabContent = get(tab);
      if (tabContent) {
        tabContent.classList.add("tab-content--active");
      }
    }
    if (activeTab && activeTab.getAttribute("data-url")) {
      history.replaceState({ tabId: activeTab.id }, null, window.location.href);
    }
  });

  $$(".tabs-menu__item").forEach(elem => {
    elem.addDataBoundEventListener("click", onTabClick, "tabs");
    elem.addDataBoundEventListener("keydown", (e: KeyboardEvent) => {
        clickOnEnterKey(e, elem)
    }, "enter-keypress-bound");
  });
}

window.addEventListener("popstate",
  e => {
    if (e.state && e.state.tabId) {
      selectTab(get(e.state.tabId));
    }
  });

window.addEventListener("resize", () => {
  if (!window.isResponsive && get("newsListContainer")) {
    $$(".tabs-menu").forEach(x => {
      if (!x.querySelector(".tabs-menu__item--active"))
        (x.querySelector(".tabs-menu__item") as HTMLElement).click()
    })
  }
})
